<template>
    <div>
        <b-carousel
            id="carousel-fade"
            style="text-shadow: 0px 0px 2px #000;max-height: 340px;overflow: hidden;"
            v-model="slide"
            :interval="2000"
            background="#ababab"
            img-width="1920px"
            img-height="340px"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
        >
            <b-carousel-slide :img-src="`https://api.100xsys.cn/file/download?fileNo=${item.carousel_img}`" v-for="(item,index) in webSitePcCarousel"></b-carousel-slide>
        </b-carousel>
        <b-container style="" class="d-none d-sm-block">
            <b-navbar type="light" variant="light" class="search-bar m-2" >
                <b-nav-form class="w-100">
                    <b-form-input class="flex-grow-1 form-control-lg" v-model="searchVal" placeholder="请输入你想要得政策关键字，一键搜索"></b-form-input>
                    <b-button variant="primary"  size="lg" class="my-2 my-lg-0 h-100" lg @click="onSearchBtn(searchVal)"><b-icon icon="search"></b-icon>搜索</b-button>
                </b-nav-form>
            </b-navbar>
            <b-row  class="p-0 m-0">
                <b-col  :cols="12"  class="pb-3 p-2 m-0 pb-0">
                    <layoutUnitMap></layoutUnitMap>
                </b-col>
            </b-row>
           
            <b-row  class="p-0 m-0">
                <b-col     sm="12"  :md="12 * layout.row" class="pb-3 p-2 m-0"  v-for="(layout,i) in layoutMapRun" >
                    <layoutUnit :type="layout.type" :variant="layout.type == 'banner' ? 'white' : null" :content="layout.content" :icon="layout.icon" :title="layout.title"></layoutUnit>
                </b-col>
            </b-row>
            
        </b-container>
        <b-container class=" d-block d-sm-none">
            <b-row  class="p-0 m-0">
                <b-col  :cols="12"  class="pb-3 p-2 m-0 pb-0">
                    <layoutUnitMap></layoutUnitMap>
                </b-col>
            </b-row>
           
            <b-row  class="p-0 m-0">
                <b-col     sm="12"  :md="12 * layout.row" class="pb-3 p-2 m-0"  v-for="(layout,i) in layoutMapRun" >
                    <layoutUnit :type="layout.type" :variant="layout.type == 'banner' ? 'white' : null" :content="layout.content" :icon="layout.icon" :title="layout.title"></layoutUnit>
                </b-col>
            </b-row>
            
        </b-container>
    </div>
  </template>
  
  <script>
  
  import layoutUnit from '@/components/layoutUnit.vue'
  import layoutUnitMap from '@/components/layoutUnitMap.vue'

  import jingdubg from '@/assets/jingdubg.png'
  import zuirebg from '@/assets/zuirebg.png'
  import pipeibg from '@/assets/pipeibg.png'
  //
  import dianhua from '@/assets/dianhua.png'
  import xiaochengxubanner from '@/assets/xiaochengxubanner.png'
  import gongzhonghaobanner from '@/assets/gongzhonghaobanner.png'
  // 图标
  import zuixinicon from '@/assets/zuixinicon.png'
  import zhuangkuangicon from '@/assets/zhuangkuangicon.png'
  import jianbaoicon from '@/assets/jianbaoicon.png'
  
import store from '@/store'
  import { friendLinks } from '@/api/api.js'
import { ref } from 'vue'
  export default {
    name: 'homeLayout',
    components: {
        layoutUnit,layoutUnitMap
    },
    props: {
      msg: String
    },
    computed:{
        webSitePcCarousel(){
            let info = ''
            info = sessionStorage.getItem('webSitePcCarousel') ? this.bxDeepClone( JSON.parse(sessionStorage.getItem('webSitePcCarousel'))) : null

            return info
        },
        layoutMapRun(){
            let arr = [
                
//             {
//                 title:"",
//                 type:"text",
//                 content:{
//                     subText:"企业规划",
//                     textList:['第一阶段2022年-2023年',
// '陕西、山西、河南3个省份，省市区三级、六个部门政策查询。',
// '（1）其他20个省份、5个自治区、4个直糖市，省市区三级、六个部门政策查询。',
// '（2）陕西省10个区县建立业务联络点(区县级)。3个省会城市建立业务联络点(市级)。',
// '第二阶段2024年-2025年',
// '（1）全国建立5个业务联络点(市级)。以省会城市为主',
// '（2）陕西省区县建立业务联络点不低于100个(区县级)',
// '第三阶段2026年-2027年',
// '（1）公司全国不低于10个省会城市建立联络点或者子公司',
// '（2）西部省会城市建立自己的分子公司']
//                 },
//                 icon:""
//             },
            {
                title:"行业专业现状",
                type:"list",
                row:1,
                icon:zhuangkuangicon,
                
                content:[
                    {
                            title:"各省企业政策补贴排行榜",
                            serviceName:"srvcosvc_policy_subsidy_select",
                                app:"fyzhmd",
                                filter:true,
                            type:"list",
                            footer:"more",
                            row:1,
                            templateType:"1",
                            pageRowNumber:6
                        },[
                            {
                                title:"各省高新技术企业排行榜",
                                serviceName:"srvcosvc_enterprise_list_select",
                                "order": [{"colName":"rank","orderType":"asc"}],
                                "condition":[{"colName":"type","ruleType":"eq","value":"高新技术"}],
                                app:"fyzhmd",
                                type:"chart",
                                footer:"more",
                                row:1
                            },
                            {
                                title:"各省专精特新中小企业排行榜",
                                serviceName:"srvcosvc_enterprise_list_select",
                                "order": [{"colName":"rank","orderType":"asc"}],
                                "condition":[{"colName":"type","ruleType":"eq","value":"专精特新"}],
                                 app:"fyzhmd",
                                type:"chart",
                                footer:"more",
                                row:1
                            }
                        ]
                ]
            },{
                title:"最新政策",
                subTitle:"全国最新政策文件早知道",
                type:"list",
                row:0.5,
                icon:zuixinicon,
                content:[
                    {
                        title:"",
                        serviceName:"srvcosvc_policy_info_user_hot_select",
                        app:"fyzhmd",
                        type:"list",
                        footer:"more",
                        row:1,
                        templateType:"2",
                        pageRowNumber:8
                    }
                ]
            },{
                title:"每日简报",
                type:"list",
                subTitle:"最新政策一句话解读",
                row:0.5,
                icon:jianbaoicon,
                content:[
                    {
                        title:"",
                        serviceName:"srvdaq_cms_content_jianbao_select",
                        type:"list",
                        footer:"more",
                        row:1,
                        templateType:"3",
                        pageRowNumber:4
                    }
                ]
            },{
                title:"",
                type:"banner",
                subTitle:"",
                row:1,
                content:[
                    {
                        title:"政策精读",
                        subTitle:"企业最关注的政策精华都在这",
                        serviceName:"srvdaq_cms_content_jianbao_select",
                        backgroundImg:jingdubg,
                        type:"banner",
                        footer:"more",
                        row:1,
                        templateType:"0",
                        pageRowNumber:4,
                        url:'/policy'
                    },
                    {
                        title:"最热政策",
                        subTitle:"全国最热政策文件一键查",
                        serviceName:"",
                        backgroundImg:zuirebg,
                        type:"banner",
                        footer:"more",
                        row:1,
                        templateType:"0",
                        pageRowNumber:4,
                        url:'/zhengCeHot'
                    }
                ]
            },{
                title:"",
                type:"banner",
                subTitle:"",
                row:1,
                content:[
                    {
                        title:"政策匹配",
                        subTitle:"企业最合适的政策都在这",
                        backgroundImg:pipeibg,
                        serviceName:"",
                        type:"banner",
                        footer:"",
                        row:1,
                        templateType:"0",
                        pageRowNumber:4,
                        url:'/zhengCePiPei'
                    }
                ]
            },{
                title:"",
                type:"banner",
                subTitle:"",
                row:1,
                content:[
                    {
                        title:"",
                        subTitle:"",
                        serviceName:"",
                        backgroundImg:dianhua,
                        type:"banner",
                        footer:"more",
                        row:1,
                        templateType:"0",
                        pageRowNumber:4
                    },{
                        title:"",
                        subTitle:"",
                        serviceName:"",
                        backgroundImg:xiaochengxubanner,
                        type:"banner",
                        footer:"more",
                        row:1,
                        templateType:"0",
                        pageRowNumber:4
                    },{
                        title:"",
                        subTitle:"",
                        serviceName:"",
                        backgroundImg:gongzhonghaobanner,
                        type:"banner",
                        footer:"more",
                        row:1,
                        templateType:"0",
                        pageRowNumber:4
                    }
                ]
            },{
                title:"友情链接",
                type:"cards",
                subTitle:"",
                row:1,
                content:this.friendLinksDatas
            }]
            return arr
        }
    },
    data(){
        return {
            searchVal:"",
            slide: 0,
            sliding: null,
            contentText:{
                subText:"企业规划",
                textList:['第一阶段2022年-2023年陕西、山西、河南3个省份，省市区三级、六个部门政策查询',
                '(1)其他20个省份、5个自治区、4个直辖市，省市区三级、六个部门政策查询。',
                '(2)陕西首10个区县建立业务联络点 (区县级)，3个省会城市']
            },
            friendLinksDatas:[],
            layoutMap:[]
        }
    },
    mounted(){
        this.getFriendLinks()
    },
    methods:{
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        },
        getFriendLinks(){
            let req = {
                "serviceName":"srvcms_friend_links_select",
                "colNames":["*"],
                "condition":[{"colName":"website_no","ruleType":"eq","value":"PCWS202209050001"}],
                "relation_condition":{},"page":{"pageNo":1,"rownumber":999},"order":[]
            }


            friendLinks(req).then((res) =>{
                // console.log('--友情链接--',res)
                if(res.state == "SUCCESS"){
                    this.friendLinksDatas = res.data.map((item) =>{
                        let obj =  {
                            title:`${item.link_name}`,
                            subTitle:"",
                            serviceName:"",
                            backgroundImg:`https://api.100xsys.cn/file/download?fileNo=${item.link_logo}&bx_auth_ticket=${store.getters.token}`,
                            type:"cards",
                            footer:"more",
                            row:2/6,
                            templateType:"1",
                            pageRowNumber:4,
                            url:item.link_url
                        }
                        return obj
                    })
                }
                
            })
        },
        onSearchBtn(e){
            let search = [{
                name:"policy_title@policy_industry",
                value:e
            }]
            this.onSearch(search)
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
 .search-bar{
    justify-content: center;
    position: relative;
    // top: -40px;
    border-radius: 8px;
    height: 80px;
    list-style: none;
    & > li{
        width: calc(100% - 40px);
        form{
            display: flex;
            width: 100%;
            justify-content: space-between;
            button{
                width: 140px;
                margin-left: 10px;
            }
        }
    }
 }
  </style>
  